import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ResendStatus } from '../../containers/ConfirmEmailContainer';

interface IProps {
  resendStatus: ResendStatus;
  onResendActivationEmailClick: () => Promise<void>;
}

export const ResendEmail = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='auth-link'>
      {props.resendStatus === 'NotSent' && (
        <>
          {t('didnt_receive')}
          <a
            href='#'
            onClick={() => {
              void props.onResendActivationEmailClick();
            }}
          >
            {t('resend')}
          </a>
        </>
      )}
      {props.resendStatus === 'Sending' && <>{t('resending_email')}...</>}
      {props.resendStatus === 'Sent' && <>{t('email_sent')}</>}
    </div>
  );
});
